import auth from "./apis/authentication";
import account from "./apis/account";
import notifications from "./apis/notifications";
import finder from "./apis/finder";
import applications from "./apis/applications";

export const apiService = {
  auth,
  account,
  notifications,
  finder,
  applications
};
